module.exports = __webpack_public_path__ + "img/4_003.19bcdf41.webp";